import React from 'react';
import {
    Typography,
} from "@mui/material";

import { _date } from "../../../utils/helpers";

export const SubscriberColumns = () => [
    {
        id: "email",
        label: "Email",
        render: (value, row) => {
            return (
                <Typography variant="body2" sx={{ fontWeight: 500 }}>
                    {value}
                </Typography>
            );
        }
    },
    {
        id: "created_at",
        label: "Subscribed Date",
        render: (value, row) => {
            return (
                <Typography sx={{ color: "text.secondary", textAlign: 'center' }}>
                    {_date(value, { relative: true })}
                </Typography>
            );
        }
    },
];
